export const ROUTES = {
    LOGIN: "/login",
    REGISTER: "/register",
    HOME: "/",
    ACCOUNT: "/account",
    CALENDAR: "calendar/",
    STATISTICS: "statistics",
    NotFound: '*',

};